import React, { useEffect } from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function Share({ title = '', open = false, handleClose }) {
    const shares = [
        { icon: "icon-whatsapp", title: "WhatsApp", description: "Share this on your WhatsApp", key: "whatsapp", },
        { icon: "icon-twitter2", title: "Twitter", description: "Tweet this to your audience", key: "twitter", },
        { icon: "icon-facebook2", title: "Facebook", description: "Share this or post to your audience", key: "facebook", },
        { icon: "icon-linkedin22", title: "LinkedIn", description: "Share this or post to your audience", key: "linkedin", },
        { icon: "icon-mail5", title: "Email", description: "Send an email about this", key: "email", },
        { icon: "icon-file", title: "Copy", description: "Copy the link to URL to the clipboard", key: "copy", },
    ];
    const share = option => {
        var current_url = window.location.href;
        if (option === 'linkedin') {
            window.open("https://www.linkedin.com/shareArticle?url=" + encodeURIComponent(current_url) + "&title=" + title, "_blank");
        } else if (option === 'twitter') {
            window.open("http://www.twitter.com/intent/tweet?url=" + encodeURIComponent(current_url) + "&via=nzuqi&text=" + title, "_blank");
        } else if (option === 'facebook') {
            window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(current_url), "_blank");
        } else if (option === 'whatsapp') {
            window.open("https://wa.me/?text=" + encodeURIComponent(current_url), "_blank");
        } else if (option === 'copy') {
            if (navigator.clipboard.writeText(current_url)) {
                const _saveMessage = `The link has been copied successfully to your clipboard.`;
                console.log(_saveMessage);
            } else {
                console.log('An error ocurred copying the link.');
            }
        } else if (option === 'email') {
            window.open("mailto:?subject=" + encodeURIComponent(title) + "&body=" + encodeURIComponent("Hey, you really have to check this out " + current_url + "\n\n\n"), "_top");
        } else if (option === 'pocket') {
            window.open("https://getpocket.com/save?url=" + encodeURIComponent(current_url) + "&title=" + title, "_blank");
        }
        handleClose(false);
    }
    useEffect(() => {
        try {
            document.getElementsByClassName('MuiDialog-paperScrollPaper')[0].classList.add('martin-scrollbar');
        } catch (error) {
            // console.log(error);
        }
    });
    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => handleClose(false)}
                aria-labelledby="share-dialog-slide-title"
                aria-describedby="share-dialog-slide-description"
                maxWidth={"xs"}
                fullWidth={false}
            >
                <DialogTitle id="share-dialog-slide-title" style={{ paddingBottom: '4px' }}>Share</DialogTitle>
                <div style={{ margin: '0 24px' }}>
                    <DialogContentText id="share-dialog-slide-description" style={{ marginBottom: 0 }}>
                        Select from the avilable options to<br />share this page.
                    </DialogContentText>
                </div>
                <List className="share-list">
                    {shares.map(s => (
                        <ListItem button onClick={() => share(s.key)} key={s.key}>
                            <ListItemIcon>
                                <i className={s.icon}></i>
                            </ListItemIcon >
                            <ListItemText primary={s.title} secondary={s.description} />
                        </ListItem>
                    ))}
                </List>
            </Dialog>
        </>
    );
}
